<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Zakelijke verhuizing?</h1>
      <p>
        Staat er bij u een zakelijke verhuizing op de agenda en wilt u graag
        gebruik maken van een professioneel verhuisbedrijf? Zorg er dan voor dat
        u niet meer uitgeeft dan nodig is en vergelijk eerst offertes van
        verschillende verhuizers bij u in de buurt. Zo weet u exact bij welk
        bedrijf u het goedkoopst uit bent en kunt u euro’s besparen op uw
        zakelijke verhuizing. De overstap van het ene naar het andere kantoor
        brengt al genoeg geregel en kosten met zich mee, dus ben er in ieder
        geval zeker van dat u een voordelig verhuisbedrijf inschakelt!
      </p>

      <h2>Gemakkelijk én goedkoop</h2>
      <p>
        De verhuizers die u helpen tijdens uw zakelijke verhuizing regelt u
        binnen no time via Alleverhuizers.nl. U hoeft slechts enkele
        persoonlijke gegevens en de belangrijkste informatie over uw verhuizing
        achter te laten op de website, waarna u helemaal gratis én binnen 24 uur
        verschillende offertes ontvangt van verhuisbedrijven die het dichtst bij
        uw postcoderegio actief zijn. Op die manier vergelijkt u vrijblijvend de
        tarieven van regionale verhuizers en kunt u precies zien bij wie uw
        zakelijke verhuizing het goedkoopst is.
      </p>

      <h2>Zakelijke verhuizing direct regelen?</h2>
      <p>
        Ook als uw zakelijke verhuizing niet op korte termijn gepland staat,
        doet u er goed aan om snel offertes aan te vragen. Verhuizen brengt al
        genoeg geregel met zich mee, dus u kunt maar beter ruim van tevoren
        beslissen met welk verhuisbedrijf u in zee gaat. Vraag daarom snel
        gratis en vrijblijvend offertes aan, vergelijk morgen nog de
        verschillende tarieven en maak een weloverwogen keuze voor de beste en
        voordeligste <nuxt-link to="/"> verhuizers </nuxt-link> in uw omgeving!
      </p>
      <p>
        Ook voor een
        <nuxt-link to="/informatie-over-verhuizers/particuliere-verhuizingen">
          particuliere verhuizing
        </nuxt-link>
        of een
        <nuxt-link to="/informatie-over-verhuizers/internationale-verhuizingen">
          internationale verhuizing
        </nuxt-link>
        bent u op Alleverhuizers.nl natuurlijk aan het goede adres.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Zakelijke verhuizing? Vraag gratis verschillende offertes aan!',
      headDescription:
        'Heb je een zakelijke verhuizing op de agenda staan? Vergelijk gratis meerdere offertes via Alleverhuizers.nl en bespaar tot honderden euro’s! ',
    }
  },
}
</script>
